import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { aboutImage } from "../mock";

const About = () => {
  return (
    <section id="about" className="relative py-20 lg:py-28 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <div className="absolute -inset-4 bg-sterling/20 rounded-3xl -z-10" />
          <img
            src={aboutImage}
            alt="Elegant kitchen"
            className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
          />
          <div className="absolute -bottom-8 -right-4 lg:-right-8 bg-white rounded-2xl p-6 shadow-xl border border-[#ead8c9] max-w-[240px] hidden md:block">
            <div className="font-serif-display text-3xl text-ink">100%</div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#daae9c] mt-1">
              Tailored to your home
            </div>
            <div className="text-sm text-ink/60 mt-2">
              Every home is assessed individually — never a generic checklist.
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#daae9c]">
            <span className="w-6 h-px bg-sterling-dark" />
            About Us
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-[1.05] text-balance">
            We don’t just clean —{" "}
            <span className="italic text-[#daae9c]">we transform.</span>
          </h2>
          <p className="mt-6 text-ink/70 leading-relaxed">
            The Sterling Touch delivers refined property presentation with
            meticulous attention to detail. We provide premium cleaning services
            for homes and property transitions.
          </p>
          <p className="mt-4 text-ink/70 leading-relaxed">
            Our service is built for discerning homeowners who value beautifully
            presented spaces, precision, and a service they can rely on. Every
            clean is delivered as a structured, tailored package — never rushed, never
            surface-level.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4">
            {[
              "Precision & care",
              "Discreet, respectful service",
              "Flexible scheduling",
              "Presentation-level finish",
            ].map((t) => (
              <div
                key={t}
                className="flex items-center gap-3 p-4 rounded-xl bg-white border border-[#ead8c9]"
              >
                <div className="w-2 h-2 rounded-full bg-sterling-dark" />
                <span className="text-sm text-ink">{t}</span>
              </div>
            ))}
          </div>

          <a href="#services" className="inline-block mt-8">
            <Button className="rounded-full bg-[#daae9c] hover:bg-white text-ink border border-transparent hover:border-[#daae9c] transition-colors px-6 h-12 group">
              Discover our services
              <ArrowRight
                size={16}
                className="ml-2 group-hover:translate-x-1 transition-transform"
              />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
